import React, { Component } from 'react';
import LandingPanel from "../landingPagePanel/landingPagePanel";
import LandingSidebar from "../landingSidebar/landingSidebar";

const mlnetSidebarLinks = [
    {label: 'Overview', to: '/machine-learning/tutorials/mlnet/'},
];

const gettingStartedTutorials = [
    {id: 1,
        title: 'CLI Installation',
        content: 'Installing ML.NET to create and train a model from the command line ',
        image:"/images/machine-learning-frameworks/getting-started-cli.svg",
        slug:'getting-started-cli',
        enabled: true},
    {id: 2,
        title: 'Training a model in the IDE',
        content: 'An example showing how to create and train a model from within the IDE',
        image:"/images/machine-learning-frameworks/getting-started-ide.svg",
        slug:'getting-started-ide',
        enabled: true},

    {id: 3,
        title: '.NET Interactive Notebooks ',
        content: 'How to get started with .NET interactive notebooks',
        image:"/images/machine-learning-frameworks/interactive-notebook.svg",
        slug:'dotnet-interactive-notebook',
        enabled: true},
    {id: 4,
        title: 'Interactive Iris classification',
        content: 'The Iris classification problem in an interactive notebook',
        image:"/images/machine-learning-frameworks/interactive-notebook.svg",
        slug:'interactive-iris-classification',
        enabled: true}
];

const classificationTutorials = [
    {id: 1,
        title: 'Binary Classification',
        content: 'Classification example using the well known Titanic dataset',
        image:"/images/machine-learning-frameworks/classification.svg",
        slug:'mlnet-titanic-binary-classification',
        enabled: true},
    {id: 2,
        title: 'Interactive Binary Classification',
        content: 'Interactive notebook example using the Titanic dataset',
        image:"/images/machine-learning-frameworks/classification.svg",
        slug:'mlnet-interactive-titanic-binary-classification',
        enabled: true},
    {id: 3,
        title: 'Binary Image Classification',
        content: 'How to get started with image classification',
        image:"/images/machine-learning-frameworks/image-classification.svg",
        slug:'mlnet-binary-image-classification',
        enabled: true},
    {id: 4,
        title: 'Multi Image Classification',
        content: 'Classifying multiple images with a prebuilt tensorflow model',
        image:"/images/machine-learning-frameworks/image-classification.svg",
        slug:'mlnet-multi-image-classification',
        enabled: true}

];

const regressionTutorials = [
    {id: 1,
        title: 'Simple Linear Regression',
        content: 'Regression example using New York taxi data',
        image:"/images/machine-learning-frameworks/regression.svg",
        slug:'mlnet-linear-regression',
        enabled: false},
    {id: 2,
        title: 'Interactive Time Series Analysis',
        content: 'Investigating how to train and evaluate time series data with ML.NET',
        image:"/images/machine-learning-frameworks/time-series.svg",
        slug:'mlnet-interactive-time-series',
        enabled: true},
    {id: 3,
        title: 'Stock Prediction (time series analysis)',
        content: 'Stock prediction example with ML.NET',
        image:"/images/machine-learning-frameworks/time-series.svg",
        slug:'mlnet-stock-price-prediction',
        enabled: true}

];

const imageTutorials = [
    {id: 1,
        title: 'Basic Regression tutorial page',
        content: 'A basic classification example using the well known IRIS dataset which classifies Iris flowers based on their features',
        image:"/images/panel-regression.svg",
        slug:'mlnet-basic-regression-tutorial',
        enabled: false},
    {id: 2,
        title: 'Image Classification',
        content: 'How to get started with image classification',
        image:"/images/panel-image-classification.svg",
        slug:'mlnet-binary-image-classification',
        enabled: false},

];

const nlpTutorials = [
    {id: 1,
        title: 'Introduction to NLP',
        content: 'Natural Language Processing with ML.NET',
        image:"/images/machine-learning-frameworks/nlp-classification.svg",
        slug:'mlnet-nlp-text-classification'},
    {id: 2,
        title: 'Sentence Similarity',
        content: 'Compare sentences to determine their similarity ',
        image:"/images/machine-learning-frameworks/nlp-classification.svg",
        slug:'mlnet-nlp-sentence-similarity'}

];

const MlnetLanding = () => {


    return (
        <div className="relative space-y-4 flex flex-col md:grid md:space-y-0 w-full md:grid-cols-12 2xl:grid-cols-12 md:flex-1 md:grid-rows-full rounded-2xl overflow-hidden">
            <LandingSidebar title="Microsoft ML.NET" links={mlnetSidebarLinks}/>
            <section className="pt-2 border-gray-200 md:col-span-10 lg:col-span-10 2xl:col-span-10">
            <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                <div className="w-full px-4">
                        <div className="flex items-center mb-8">
                            <svg className="text-red-400 text-2xl mr-3 flex-none" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                <path d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8" stroke="#222222"  strokeWidth="1.2" opacity="0.5"/>
                            </svg>
                            <h2 className="text-2xl font-semibold leading-tight text-blue-800">Getting started</h2>
                        </div>
                        <div className="grid lg:grid-cols-3 gap-4">
                        {gettingStartedTutorials.map((data) => (
                            <LandingPanel key={data.id}  title={data.title} imageSource={data.image} to={"/machine-learning/tutorials/mlnet/" + data.slug} strapLine={data.content}  />
                        ))}
                    </div>
                </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                <div className="w-full px-4">
                        <div className="flex items-center mb-8">
                            <svg className="text-blue-400 text-2xl mr-3 flex-none" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                <path d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8" stroke="#222222"  strokeWidth="1.2" opacity="0.5"/>
                            </svg>
                            <h2 className="text-2xl font-semibold leading-tight text-blue-800">Classification</h2>
                        </div>
                        <div className="grid lg:grid-cols-3 gap-4">
                        {classificationTutorials.map((data) => (
                            <LandingPanel key={data.id}  title={data.title} imageSource={data.image} to={"/machine-learning/tutorials/mlnet/" + data.slug} strapLine={data.content}  />
                        ))}
                    </div>
                </div>
            </div>


            <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                <div className="w-full px-4">
                        <div className="flex items-center mb-8">
                            <svg className="text-green-400 text-2xl mr-3 flex-none" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                <path d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8" stroke="#222222"  strokeWidth="1.2" opacity="0.5"/>
                            </svg>
                            <h2 className="text-2xl font-semibold leading-tight text-blue-800">Regression</h2>
                        </div>
                        <div className="grid lg:grid-cols-3 gap-4">
                        {regressionTutorials.map((data) => (
                            <LandingPanel key={data.id}  title={data.title} imageSource={data.image} to={"/machine-learning/tutorials/mlnet/" + data.slug} strapLine={data.content}  />
                        ))}
                    </div>
                </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                <div className="w-full px-4">
                        <div className="flex items-center mb-8">
                            <svg className="text-fuchsia-800 text-2xl mr-3 flex-none" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                <path d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8" stroke="#222222"  strokeWidth="1.2" opacity="0.5"/>
                            </svg>
                            <h2 className="text-2xl font-semibold leading-tight text-blue-800">Natural Language Processing</h2>
                        </div>
                        <div className="grid lg:grid-cols-3 gap-4">
                        {nlpTutorials.map((data) => (
                            <LandingPanel key={data.id} title={data.title} imageSource={data.image} to={"/machine-learning/tutorials/mlnet/" + data.slug} strapLine={data.content}  />
                        ))}
                    </div>
                </div>
            </div>
            </section>
        </div>
    )


}

export default MlnetLanding;